export enum Faction {
    Unspecified = 1,
    Resistance = 2,
    Enlightened = 3
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/types/Faction.ts